export enum stepEnum {
  CategoryFlow,
  TreeFlow,
  RuleEngine,
  LiveChatFlow,
  ResolveEnd,
  WaitRuleEngine,
  WaitRuleEngine2,
  ChatRating,
  ActiveConversation,
  AddComment
};
